import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { formatDateCustom } from "@app/shared/formatDateTime";
import { QESButton } from "@app/shared/qes-standards/Button";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { PrimaryTable as SkeletonTable } from "@app/shared/skeleton-components";
import { JSX } from "react";

interface PciDashboardSkeletonProps {
  showLineOfBusiness?: boolean;
}

const PciDashboardSkeleton = (props: PciDashboardSkeletonProps): JSX.Element => {
  return (
    <div className="skeleton shimmer">
      <div className="row">
        <div className="col-12">
          <div className="card card-static">
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <label className="label-m mb-2 bone">
                    Filters
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <QESSelect
                    className="bone"
                    testId="pci-dashboard__filters--skeleton-service-area"
                    disabled={true}
                    label={(<span className="bone">Service Area</span>)}
                    value=""
                  />
                </div>
                <div className="col-md-2">
                  <QESSelect
                    className="bone"
                    testId="pci-dashboard__filters--skeleton-specialty"
                    disabled={true}
                    label={(<span className="bone">Specialty</span>)}
                    value=""
                  />
                </div>
                {props.showLineOfBusiness && (
                  <div className="col-md-2">
                    <QESSelect
                      className="bone"
                      testId="pci-dashboard__filters--skeleton-line-of-business"
                      disabled={true}
                      label={(<span className="bone">Line of Business</span>)}
                      value=""
                    />
                  </div>
                )}
                <div className={`${props.showLineOfBusiness ? "col-md-5" : "col-md-7"} d-flex align-items-end justify-content-end`}>
                  <div>
                    <QESButton
                      disabled={true}
                      qesTestId="pci-dashboard__filters--skeleton-apply"
                      qesType="secondary"
                      className="pb-0 pe-0 me-2 bone"
                    >
                      Apply
                    </QESButton>

                    <QESButton
                      disabled={true}
                      qesTestId="pci-dashboard__filters--skeleton-clear"
                      qesType="secondary-danger"
                      className="pb-0 ps-0 bone"
                    >
                      Clear
                    </QESButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {Object.values(ProviderNetworkTypeEnum).filter(x => x !== ProviderNetworkTypeEnum.Unknown && x !== ProviderNetworkTypeEnum.NextClosestProviders).map((providerNetworkType, index) => (
          <DashboardTile
            key={index}
            classNames="pci-dashboard__summary-tile"
            title={(
              <span className="bone">
                {providerNetworkType}
              </span>
            )}
            widthClass="col-md-4"
          >
            <SkeletonTable
              columnGroupHeader={false}
              customColumns={["col-sep-mask-1", "pci-col-sep-mask-3", "pci-col-sep-mask-4", "col-sep-mask-8"]}
              hideHeader={true}
              rows={props.showLineOfBusiness ? 6 : 9}
            />
          </DashboardTile>
        ))}
      </div>
      <div className="row">
        <DashboardTile
          classNames="pci-dashboard__summary-tile"
          title={(
            <span className="bone">
              County Summary Averages
            </span>
          )}
          subtitle={(
            <span className="bone">
              As of {formatDateCustom(new Date(), "MMMM DD, YYYY")}
            </span>
          )}
          widthClass="col-md-6"
        >
          <SkeletonTable
            columnGroupHeader={false}
            customColumns={["col-sep-mask-1", "pci-col-sep-mask-2", "pci-col-sep-mask-3", "pci-col-sep-mask-4", "col-sep-mask-8"]}
          />
        </DashboardTile>

        <DashboardTile
          classNames="pci-dashboard__summary-tile"
          title={(
            <span className="bone">
              Specialty Summary Averages
            </span>
          )}
          subtitle={(
            <span className="bone">
              As of {formatDateCustom(new Date(), "MMMM DD, YYYY")}
            </span>
          )}
          widthClass="col-md-6"
        >
          <SkeletonTable
            columnGroupHeader={false}
            customColumns={["col-sep-mask-1", "pci-col-sep-mask-2", "pci-col-sep-mask-3", "pci-col-sep-mask-4", "col-sep-mask-8"]}
          />
        </DashboardTile>
      </div>
    </div>
  );
}

export default PciDashboardSkeleton;
